import { InvoiceStatusType, InvoiceTransactionActionType, InvoiceTransitionDto } from 'types/invoices';

const getTransitionsToStatus = (
    invoiceTransitions: InvoiceTransitionDto[] | undefined,
    status: InvoiceStatusType
): InvoiceTransitionDto[] =>
    (invoiceTransitions ?? []).filter((transition) => transition.toInvoiceStatusType === status);

// A rejection is stored as a transition into the previous status, so it would otherwise overwrite
// the date and employee of the transition that originally brought the invoice into that status.
export const findLatestNonRejectedTransition = (
    invoiceTransitions: InvoiceTransitionDto[] | undefined,
    status: InvoiceStatusType
): InvoiceTransitionDto | undefined =>
    getTransitionsToStatus(invoiceTransitions, status)
        .filter((transition) => transition.invoiceTransitionActionType !== InvoiceTransactionActionType.REJECTED)
        .sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime() || b.id - a.id)[0];

export const wasEverInStatus = (
    invoiceTransitions: InvoiceTransitionDto[] | undefined,
    status: InvoiceStatusType
): boolean => getTransitionsToStatus(invoiceTransitions, status).length > 0;
